// @flow

type Params = {
  anchorId: string,
  behavior?: ('auto' | 'instant' | 'smooth'),
  block?: ('center' | 'end' | 'start'),
  inline?: ('start' | 'center' | 'end' | 'nearest'),
};

const scrollToAnchor = ({
  anchorId,
  behavior = 'smooth',
  block = 'start',
  inline = 'nearest',
}: Params) => {
  const element = document.getElementById(anchorId);
  if (element) {
    const options = {
      behavior,
      block,
      inline,
    };

    // TODO: there should be a way to fix this without the setTimeout.
    //       For now the only way to make behavior smooth work properly
    setTimeout(() => element.scrollIntoView(options), 50);
  }
};

export default scrollToAnchor;
